export { default } from './ui/image';
